import React, { useState } from 'react';
import { useAdmin } from '../../contexts/AdminContext';
import { useOrgs, createOrg, createMaterial, createIncident, createClaim } from '../../hooks/useLibraryData';
import OrgForm from './OrgForm';
import MaterialForm from './MaterialForm';
import IncidentForm from './IncidentForm';
import ClaimForm from './ClaimForm';
import './Admin.css';

const AdminToolbar = () => {
  const { isAdmin, logout } = useAdmin();
  const { orgs, refetch: refetchOrgs } = useOrgs();
  const [showOrgForm, setShowOrgForm] = useState(false);
  const [showMaterialForm, setShowMaterialForm] = useState(false);
  const [showIncidentForm, setShowIncidentForm] = useState(false);
  const [showClaimForm, setShowClaimForm] = useState(false);

  if (!isAdmin) {
    return null;
  }

  const handleLogout = () => {
    if (window.confirm('Log out of admin mode?')) {
      logout();
    }
  };

  const handleCreateOrg = async (data) => {
    await createOrg(data);
    refetchOrgs();
  };

  const handleCreateMaterial = async (data) => {
    await createMaterial(data);
  };

  const handleCreateIncident = async (data) => {
    await createIncident(data);
  };

  const handleCreateClaim = async (data) => {
    await createClaim(data);
  };

  return (
    <>
      <div className="admin-toolbar">
        <div className="admin-toolbar-content">
          <div className="admin-toolbar-status">
            <span className="admin-toolbar-indicator"></span>
            <span>Admin</span>
          </div>
          <div className="admin-toolbar-buttons">
            <button className="admin-toolbar-btn" onClick={() => setShowOrgForm(true)}>+ Org</button>
            <button className="admin-toolbar-btn" onClick={() => setShowMaterialForm(true)}>+ Material</button>
            <button className="admin-toolbar-btn" onClick={() => setShowIncidentForm(true)}>+ Incident</button>
            <button className="admin-toolbar-btn" onClick={() => setShowClaimForm(true)}>+ Claim</button>
            <button className="admin-toolbar-btn admin-toolbar-btn-logout" onClick={handleLogout}>Logout</button>
          </div>
        </div>
      </div>

      {showOrgForm && (
        <OrgForm
          orgs={orgs}
          onSave={handleCreateOrg}
          onClose={() => setShowOrgForm(false)}
        />
      )}

      {showMaterialForm && (
        <MaterialForm
          orgs={orgs}
          onSave={handleCreateMaterial}
          onClose={() => setShowMaterialForm(false)}
        />
      )}

      {showIncidentForm && (
        <IncidentForm
          orgs={orgs}
          onSave={handleCreateIncident}
          onClose={() => setShowIncidentForm(false)}
        />
      )}

      {showClaimForm && (
        <ClaimForm
          orgs={orgs}
          onSave={handleCreateClaim}
          onClose={() => setShowClaimForm(false)}
        />
      )}
    </>
  );
};

export default AdminToolbar;
